const appendCustomSchemeStyles = (element, compiledStyleHtml) => {
  element.insertAdjacentHTML('beforeend', compiledStyleHtml);
  return element;
};

export default appendCustomSchemeStyles;
